import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromFirmWareInfo from './reducers/firm-ware-info.reducer';
import { FirmWareInfoEffects } from './effects/firm-ware-info.effects';
import * as fromFirmWareLog from './reducers/firm-ware-log.reducer';
import { FirmWareLogEffects } from './effects/firm-ware-log.effects';
import * as fromFirmWareUpdate from './reducers/firm-ware-update.reducer';
import { FirmWareUpdateEffects } from './effects/firm-ware-update.effects';
import * as fromFirmWareUpdatingData from './reducers/firm-ware-updating-data.reducer';
import { FirmWareUpdatingDataEffects } from './effects/firm-ware-updating-data.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('firmWareInfo', fromFirmWareInfo.reducer),
    EffectsModule.forFeature([FirmWareInfoEffects, FirmWareLogEffects, FirmWareUpdateEffects, FirmWareUpdatingDataEffects]),
    StoreModule.forFeature('firmWareLog', fromFirmWareLog.reducer),
    StoreModule.forFeature('firmWareUpdate', fromFirmWareUpdate.reducer),
    StoreModule.forFeature('firmWareUpdatingData', fromFirmWareUpdatingData.reducer),
  ]
})
export class FirmWareModule { }
